// Bugsnag removido neste app. Stub no-op para manter a interface usada
// (bugsnagClient.notify / setUser) sem depender de @bugsnag/*.
const bugsnagClient = {
  notify: (_error: any, _onError?: (event: any) => void) => {},
  setUser: (_id?: any, _email?: any, _name?: any) => {},
};

export default bugsnagClient;
